import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
`

export const Menu = styled.div`
  
  border-right: 1px solid #D9DFF8;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 24px;
`

export const List = styled.ul`
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  flex-direction: column;
`

export const Item = styled(Link)`
  padding: 16px 0 8px;
  border-bottom: 1px solid #D9DFF8;
  text-decoration: none;
  color: #1B2852;
`